// font weight
const fontWeightBold = {
  fontWeight: 700,
};
const fontWeightMedium = {
  fontWeight: 500,
};
const fontWeightRegular = {
  fontWeight: 400,
};

//---------------------------------------------

// Heading
const h1Options = {
  fontSize: 48,
  lineHeight: "67.2px",
};
const h2Options = {
  fontSize: 40,
  lineHeight: "56px",
};
const h3Options = {
  fontSize: 32,
  lineHeight: "44.8px",
};
const h4Options = {
  fontSize: 24,
  lineHeight: "33.6px",
};
const h5Options = {
  fontSize: 20,
  lineHeight: "28px",
};
const h6Options = {
  fontSize: 16,
  lineHeight: "22.4px",
};

//---------------------------------------------

// Body
const b1Options = {
  fontSize: 24,
  lineHeight: "33.6px",
};
const b2Options = {
  fontSize: 20,
  lineHeight: "28px",
};
const b3Options = {
  fontSize: 18,
  lineHeight: "25.2px",
};
const b4Options = {
  fontSize: 16,
  lineHeight: "22.4px",
};
const b5Options = {
  fontSize: 14,
  lineHeight: "19.6px",
};
const b6Options = {
  fontSize: 12,
  lineHeight: "16.8px",
};

//---------------------------------------------

export default {
  // Heading
  "&.heading-h1-bold": {
    fontSize: h1Options.fontSize,
    lineHeight: h1Options.lineHeight,
    ...fontWeightBold,
  },
  "&.heading-h2-bold": {
    fontSize: h2Options.fontSize,
    lineHeight: h2Options.lineHeight,
    ...fontWeightBold,
  },
  "&.heading-h3-bold": {
    fontSize: h3Options.fontSize,
    lineHeight: h3Options.lineHeight,
    ...fontWeightBold,
  },
  "&.heading-h4-bold": {
    fontSize: h4Options.fontSize,
    lineHeight: h4Options.lineHeight,
    ...fontWeightBold,
  },
  "&.heading-h5-bold": {
    fontSize: h5Options.fontSize,
    lineHeight: h5Options.lineHeight,
    ...fontWeightBold,
  },
  "&.heading-h6-bold": {
    fontSize: h6Options.fontSize,
    lineHeight: h6Options.lineHeight,
    ...fontWeightBold,
  },

  //---------------------------------------------

  // Body b1
  "&.body-b1-bold": {
    fontSize: b1Options.fontSize,
    lineHeight: b1Options.lineHeight,
    ...fontWeightBold,
  },
  "&.body-b1-medium": {
    fontSize: b1Options.fontSize,
    lineHeight: b1Options.lineHeight,
    ...fontWeightMedium,
  },
  "&.body-b1-regular": {
    fontSize: b1Options.fontSize,
    lineHeight: b1Options.lineHeight,
    ...fontWeightRegular,
  },

  // Body b2
  "&.body-b2-bold": {
    fontSize: b2Options.fontSize,
    lineHeight: b2Options.lineHeight,
    ...fontWeightBold,
  },
  "&.body-b2-medium": {
    fontSize: b2Options.fontSize,
    lineHeight: b2Options.lineHeight,
    ...fontWeightMedium,
  },
  "&.body-b2-regular": {
    fontSize: b2Options.fontSize,
    lineHeight: b2Options.lineHeight,
    ...fontWeightRegular,
  },

  // Body b3
  "&.body-b3-bold": {
    fontSize: b3Options.fontSize,
    lineHeight: b3Options.lineHeight,
    ...fontWeightBold,
  },
  "&.body-b3-medium": {
    fontSize: b3Options.fontSize,
    lineHeight: b3Options.lineHeight,
    ...fontWeightMedium,
  },
  "&.body-b3-regular": {
    fontSize: b3Options.fontSize,
    lineHeight: b3Options.lineHeight,
    ...fontWeightRegular,
  },

  // Body b4
  "&.body-b4-bold": {
    fontSize: b4Options.fontSize,
    lineHeight: b4Options.lineHeight,
    ...fontWeightBold,
  },
  "&.body-b4-medium": {
    fontSize: b4Options.fontSize,
    lineHeight: b4Options.lineHeight,
    ...fontWeightMedium,
  },

  "&.body-b4-regular": {
    fontSize: b4Options.fontSize,
    lineHeight: b4Options.lineHeight,
    ...fontWeightRegular,
  },

  // Body b5
  "&.body-b5-bold": {
    fontSize: b5Options.fontSize,
    lineHeight: b5Options.lineHeight,
    ...fontWeightBold,
  },
  "&.body-b5-medium": {
    fontSize: b5Options.fontSize,
    lineHeight: b5Options.lineHeight,
    ...fontWeightMedium,
  },
  "&.body-b5-regular": {
    fontSize: b5Options.fontSize,
    lineHeight: b5Options.lineHeight,
    ...fontWeightRegular,
  },

  // Body b6
  "&.body-b6-bold": {
    fontSize: b6Options.fontSize,
    lineHeight: b6Options.lineHeight,
    ...fontWeightBold,
  },
  "&.body-b6-medium": {
    fontSize: b6Options.fontSize,
    lineHeight: b6Options.lineHeight,
    ...fontWeightMedium,
  },
  "&.body-b6-regular": {
    fontSize: b6Options.fontSize,
    lineHeight: b6Options.lineHeight,
    ...fontWeightRegular,
  },
};
